/**
 * Shared utilities
 */

/**
 * Generate a unique ID with a prefix
 */
export function generateId(prefix: string): string {
  const random = Math.random().toString(36).substring(2, 8);
  const time = Date.now().toString(36).slice(-4);
  return `${prefix}_${time}${random}`;
}
